import { ReactComponent as LoadingIcon } from 'assets/icons/refresh.svg'
import { memo } from 'react'

const FormLoading = () => {

    return (
        <div className="
            fixed
            top-0
            left-0
            right-0
            bottom-0
            bg-white
            bg-opacity-50
            flex
            items-center
            justify-center
            z-[130]
            [&>svg]:animate-spin
            [&>svg]:w-10
            [&>svg]:h-10
            [&>svg]:fill-black
        ">
            <LoadingIcon />
        </div>
    )
}

export default memo(FormLoading)

